"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StandardLogoWrapper = exports.LogoWrapper = exports.List = exports.Root = exports.classes = void 0;
const styles_1 = require("@mui/material/styles");
const PREFIX = "Footer";
exports.classes = {
    listItem: `${PREFIX}-listItem`,
    listItemIcon: `${PREFIX}-listItemIcon`,
    iconLink: `${PREFIX}-iconLink`,
    icon: `${PREFIX}-icon`,
    link: `${PREFIX}-link`,
    secondaryNavigation: `${PREFIX}-secondaryNavigation`,
    listInline: `${PREFIX}-listInline`
};
exports.Root = (0, styles_1.styled)("div")(({ theme, hasMainNavigation }) => ({
    background: theme.colours.blue900,
    color: theme.colours.white,
    paddingTop: "50px",
    [`.${exports.classes.listItem}`]: {
        margin: 0,
        padding: 0,
        marginTop: "8px"
    },
    [`.${exports.classes.listItemIcon}`]: {
        display: "inline-block",
        "& .MuiSvgIcon-root": {
            fontSize: "2em"
        }
    },
    [`.${exports.classes.iconLink}`]: {
        fill: theme.colours.storm,
        fontSize: "16px",
        "&:first-of-type": {
            marginLeft: "-4px"
        }
    },
    [`.${exports.classes.icon}`]: {
        width: "1.5em",
        color: "#cccccc"
    },
    [`.${exports.classes.link}`]: {
        color: theme.colours.storm,
        justifyContent: "flex-start",
        width: "100%",
        fontFamily: "Effra Regular",
        [theme.breakpoints.up(1024)]: {
            fontFamily: "Effra Medium"
        }
    },
    [`.${exports.classes.secondaryNavigation}`]: {
        borderTop: hasMainNavigation
            ? "1px solid rgba(255, 255, 255, 0.25)"
            : "unset",
        marginTop: "22px",
        padding: "25px 0",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        [theme.breakpoints.up("lg")]: {
            flexDirection: "row",
            alignItems: "flex-start"
        }
    }
}));
exports.List = (0, styles_1.styled)("ul")(({ theme }) => ({
    margin: "0 0 0 -8px",
    padding: 0,
    listStyleType: "none",
    [`&.${exports.classes.listInline}`]: {
        margin: "40px 0",
        textAlign: "center",
        [theme.breakpoints.up("lg")]: {
            margin: "0 40px",
            textAlign: "left"
        },
        [`.${exports.classes.listItem}`]: {
            marginTop: 0,
            textAlign: "center",
            [theme.breakpoints.up("sm")]: {
                marginRight: "16px",
                display: "inline-block"
            },
            "&:last-child": {
                marginRight: 0
            }
        },
        [`.${exports.classes.link}`]: {
            width: "auto",
            [theme.breakpoints.up("sm")]: {
                width: "100%"
            }
        }
    }
}));
exports.LogoWrapper = (0, styles_1.styled)("div")(({ theme }) => ({
    width: "70px",
    [theme.breakpoints.up("sm")]: {
        width: "75px"
    },
    [theme.breakpoints.up("lg")]: {
        width: "50px"
    }
}));
exports.StandardLogoWrapper = (0, styles_1.styled)("div")(({ theme }) => ({
    textAlign: "right",
    flex: 1,
    fill: theme.colours.storm,
    "& svg": {
        width: "125px"
    }
}));
//# sourceMappingURL=data:application/json;base64,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